import React from "react";
import { object, string } from "prop-types";
import get from "lodash/get";

import DfpAd from "../../../dfp-ad";

import "./organism2.m.css";

const Organism2 = ({ collection, adSlotId = "" }) => {
  const widgetUrl = get(collection, ["associated-metadata", "widget_url"], null);

  return (
    <div styleName="advertisement-widget">
      <div styleName="ad-slot">
        <DfpAd adtype="Home_336x280_R1" slotId={adSlotId} />
      </div>
      {widgetUrl && (
        <div styleName="widget">
          <iframe src={widgetUrl} width="350" height="550" styleName="widget-iframe"></iframe>
        </div>
      )}
    </div>
  );
};

Organism2.propTypes = {
  collection: object.isRequired,
  adSlotId: string,
};

export default Organism2;
